import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 3.7a.7.7 0 0 1 .7-.7h4.2a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V3.7Zm1.4.7v2.8h2.8V4.4H4.4ZM11.4 12.1a.7.7 0 0 1 .7-.7h4.2a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.7.7h-4.2a.7.7 0 0 1-.7-.7v-4.2Zm1.4.7v2.8h2.8v-2.8h-2.8Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.717 6.227H7.39v-1.4h.326a.7.7 0 1 1 0 1.4Zm1.257-.7a.7.7 0 0 1 .7-.7h.885a.7.7 0 1 1 0 1.4h-.885a.7.7 0 0 1-.7-.7Zm4.24 0a.7.7 0 0 1 .7-.7h.56a.7.7 0 0 1 .7.7v.559a.7.7 0 0 1-1.389.129.7.7 0 0 1-.57-.688Zm-8.387 2.19V7.39h1.4v.326a.7.7 0 0 1-1.4 0Zm9.646 1.024a.7.7 0 0 1 .7.7v.885a.7.7 0 1 1-1.4 0v-.885a.7.7 0 0 1 .7-.7Zm-8.946.233a.7.7 0 0 1 .7.7v.885a.7.7 0 1 1-1.4 0v-.885a.7.7 0 0 1 .7-.7Zm8.946 2.61a.7.7 0 0 1 .7.7v.325h-1.4v-.326a.7.7 0 0 1 .7-.7Zm-8.258 2.201a.7.7 0 0 0-1.388.13v.558a.7.7 0 0 0 .7.7h.559a.7.7 0 0 0 .129-1.388Zm2.526.688a.7.7 0 0 1 .7-.7h.885a.7.7 0 1 1 0 1.4h-.885a.7.7 0 0 1-.7-.7Zm2.842 0a.7.7 0 0 1 .7-.7h.327v1.4h-.327a.7.7 0 0 1-.7-.7Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
